import React from "react";
import { Button, Modal } from "react-bootstrap";
import {
  getPermissonRolesAction,
  editContactPermissionAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import InputMask from "react-input-mask";
import { toastMessage, humanize } from "./../Common/Common";
import * as constant from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";

class EditContactPermission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: {
        email: "",
        role: "",
        usertype: message.VENDOR,
        firstname: "",
        lastname: "",
        mobileNumber: "",
      },
      showLoader: false,
      contactRoleExists: false,
    };
  }

  componentDidMount() {
    this.props.getPermissonRolesAction().catch((err) => {});
    //console.log("parent contactData", this.props.contactData);
    //let comName = this.getDsdDataByRole(this.props.contactData.roles[0]._id);
    let dataforEdit = {
      role: this.props.contactData.roles[0]._id,
      usertype: this.props.contactData.UserData[0].usertype,
      firstname: this.props.contactData.UserData[0].firstname,
      lastname: this.props.contactData.UserData[0].lastname,
      mobileNumber:
        this.props.contactData.UserData[0].mobileNumber === null
          ? ""
          : this.props.contactData.UserData[0].mobileNumber,
      email: this.props.contactData.UserData[0].email.address,
    };
    this.setState({
      contact: dataforEdit,
      contactRoleExists: false,
      showLoader: false,
    });
  }

  /**
   * @desc update contact details
   * check if user selected custom role then first add that role using api
   * and then add user/contact with details by add contact api
   */
  updateContact(values) {
    //console.log("updateContact values", values);

    this.setState({
      showLoader: true,
    });
    var dataToPut = {
      roles: [values.role],
    };
    //console.log("dataToPut", dataToPut);

    this.props
      .editContactPermissionAction(dataToPut, this.props.contactData._id)
      .then((res) => {
        this.setState({
          showLoader: false,
        });
        if (res.status === constant.FORBIDDEN) {
          this.setState({
            contactRoleExists: true,
          });
        } else if (res.status === constant.BAD_REQUEST) {
          toastMessage(constant.ERROR, res.data);
        } else {
          // toastMessage(constant.SUCCESS, message.CONTACT_UPDATED);
          this.props.onClose();
        }
        // toastMessage(constant.SUCCESS, message.CONTACT_UPDATED);
        // this.props.onClose();
      });
  }

  setFieldValue(name, e) {
    var contact = this.state.contact;
    contact[name] = e;
    this.setState({
      contact,
    });
  }

  render() {
    return (
      <div>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <Modal.Body>
          <Formik
            validateOnBlur={true}
            initialValues={this.state.contact}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              role: Yup.string().trim().required(message.REQUIRED_VENDOR_TYPE),
            })}
            onSubmit={(values, errors) => {
              this.updateContact(values);
            }}
          >
            {({ handleChange, values, errors, setFieldValue }) => (
              <Form className="form-sm form-admin">
                <div className="form-group">
                  <label>Artist</label>
                  <Field
                    type="text"
                    className="form-control"
                    name="name"
                    value={values.firstname + " " + values.lastname}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label>
                    Permission<span className="text-danger"> *</span>
                  </label>
                  <div className="c-select">
                    <select
                      className="form-control"
                      name="role"
                      value={values.role ? values.role : ""}
                      onChange={(e) => {
                        setFieldValue("role", e.target.value);
                      }}
                    >
                      <option value="">Select</option>
                      {this.props.roles &&
                        this.props.roles.map((role) => {
                          return (
                            <option key={role._id} value={role._id}>
                              {humanize(role.name)}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <ErrorMessage
                    name="role"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                  {this.state.contactRoleExists && (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {message.CONTACT_WITH_ROLE_ALREADY_EXISTS}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <Field
                    type="email"
                    className="form-control"
                    name="email"
                    value={values.email}
                    disabled
                  />
                </div>

                <div className="form-group">
                  <label>First Name</label>
                  <Field
                    type="text"
                    name="firstname"
                    className="form-control"
                    value={values.firstname}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label>Last Name</label>
                  <Field
                    type="text"
                    name="lastname"
                    className="form-control"
                    value={values.lastname}
                    disabled
                  />
                </div>
                <div className="form-group">
                  <label>Mobile Number</label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formcontrolprops={{
                      fullWidth: true,
                    }}
                    className="form-control"
                    value={values.mobileNumber}
                    name="mobileNumber"
                    disabled
                  >
                    {(inputProps) => <Field {...inputProps} disabled />}
                  </InputMask>
                </div>

                <Button
                  variant="primary"
                  size="sm"
                  className="btn-blue w-140"
                  type="submit"
                >
                  Update
                </Button>
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contactResponse: state.reducer.contactResponse,
    roles: state.reducer.roles,
    contacts: state.reducer.contacts,
  };
};

export default connect(mapStateToProps, {
  getPermissonRolesAction,
  editContactPermissionAction,
})(EditContactPermission);
